import React, { Component } from 'react'
import { Button, Select, Card, Tag, Icon, Popconfirm } from 'antd'

export default class TagsCard extends Component<any, any> {
    state: any = {
        editingMode: false,
        selectedTag: undefined,
        error: null
    }

    toggleEditingMode = () => {
        this.props.toggleEditing()
        this.setState(prevState => ({ editingMode: !prevState.editingMode, selectedTag: undefined, error: null }))
    }

    handleSelectChange = selectedTag => {
        this.setState({ selectedTag })
    }

    handleRemoveTag = tag => {
        this.props.onRemove(tag)
    }

    handleTagSubmit = () => {
        const { singularName } = this.props
        const { selectedTag } = this.state
        if (!selectedTag) {
            this.setState({ error: `בחר ${singularName ? singularName : 'תגית'} לשיוך` })
        } else {
            this.props.onSubmit(selectedTag)
            this.toggleEditingMode()
        }
    }

    render() {
        const { tagsList, selectList, tagName, singularName, pluralName, loading, disableEditButtons } = this.props
        const { editingMode, selectedTag, error } = this.state
        const editButtons = !disableEditButtons ? (
            <a onClick={() => this.toggleEditingMode()} style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
                {`הוסף ${singularName ? singularName : 'תגית'}+`}
            </a>
        ) : (
            ''
        )
        const extraTitle =
            tagsList && editingMode ? (
                <div>
                    {!loading && selectList && selectList.length > 0 ? (
                        <Select
                            onChange={e => this.handleSelectChange(e)}
                            style={{ width: '15rem' }}
                            value={selectedTag}
                            placeholder={`בחר ${singularName ? singularName : 'תגית'} מתוך רשימה`}
                        >
                            {selectList.map((tag, index) => {
                                if (!tagsList.find(selected => selected.id === tag.id)) {
                                    return (
                                        <Select.Option key={index} value={tag.id}>
                                            {tag.name}
                                        </Select.Option>
                                    )
                                }
                            })}
                        </Select>
                    ) : (
                        ''
                    )}
                    <Button style={{ margin: '0 0.2rem 0 0.1rem' }} onClick={() => this.toggleEditingMode()}>
                        <Icon type="stop" />
                    </Button>
                    <Button disabled={loading} type="primary" onClick={() => this.handleTagSubmit()}>
                        <Icon type="check" />
                    </Button>
                    {error ? <div style={{ color: 'red' }}>{error}</div> : ''}
                </div>
            ) : (
                editButtons
            )
        return (
            <Card
                style={{ marginBottom: '0.5rem' }}
                headStyle={{ padding: '0 0.4rem' }}
                bodyStyle={{ padding: '0.4rem 0' }}
                size="small"
                type="inner"
                title={
                    editingMode
                        ? `הוספת ${singularName ? singularName : 'תגית'}`
                        : `רשימת ${pluralName ? pluralName : 'תגיות'}`
                }
                extra={loading ? <Icon type="loading" /> : extraTitle}
            >
                {tagsList && tagsList.length > 0 ? (
                    tagsList.map((tag, index) => (
                        <Tag key={index}>
                            <Popconfirm
                                placement="topLeft"
                                title={`האם ברצונך להסיר את השיוך ל${tagName ? tag[tagName] : tag}`}
                                onConfirm={() => this.handleRemoveTag(tag)}
                                okText="כן"
                                cancelText="לא"
                                disabled={disableEditButtons}
                            >
                                <a>
                                    <Icon type="close" />
                                </a>
                            </Popconfirm>
                            {tagName ? tag[tagName] : tag}
                        </Tag>
                    ))
                ) : (
                    <span style={{ padding: '0 0.4rem' }}>{`לא נמצאו ${pluralName ? pluralName : 'תגיות'}`}</span>
                )}
            </Card>
        )
    }
}
